const REQUEST_ALERTS = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_ALERTS = (state, { body }) => {
  state.Alerts = body;
  state.status = "success";
};

const FAILURE_REQUEST_ALERTS = state => {
  state.status = "failure";
};

const DELETE_ALERT = (state, id) => {
  state.Alerts = state.Alerts.filter(alert => alert._id !== id);
} ;

const SUCCESS_DELETE_ALERT = (state, id) => {
  DELETE_ALERT(state, id);
  state.status = "success";
}
const SUCCESS_DELETE_ALERTS = (state, ids) => {
  const deleted = new Set(ids);
  state.Alerts = state.Alerts.filter(alert => !deleted.has(alert._id));
  state.status = 'success';
};
const REQUEST_DELETE_ALERT = state => {
  state.status = "deleting";
};

const FAILURE_DELETE_ALERT = state => {
  state.status = "failure";
};  


export default {
  REQUEST_ALERTS,
  SUCCESS_REQUEST_ALERTS,
  FAILURE_REQUEST_ALERTS,
  REQUEST_DELETE_ALERT,
  SUCCESS_DELETE_ALERT,
  SUCCESS_DELETE_ALERTS,
  FAILURE_DELETE_ALERT
};  
